/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateSalesInvoiceDto
 */
export interface CreateUpdateSalesInvoiceDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    currency: CreateUpdateSalesInvoiceDtoCurrencyEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    status: CreateUpdateSalesInvoiceDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    paymentForm: CreateUpdateSalesInvoiceDtoPaymentFormEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    type: CreateUpdateSalesInvoiceDtoTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    invoiceDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    saleDate: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    payableDaysId: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    printProjectNumber: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    isPaymentFromReceiptDate: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    projectIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    isOnePositionOnInvoice: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    onePositionName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    exchangeRate: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    exchangeRateDescription: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    gtuCodeId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    documentCodeIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    parentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    textOverItems: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    correctionReasonTxt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    correctionReasonDictId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    companyId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    purchaserId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    recipientClientId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    budgetId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    approverId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    approvedTs?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    emailText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    emailSubject?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    toKsef: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    statusKsef?: CreateUpdateSalesInvoiceDtoStatusKsefEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    numberKsef?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    qrCodeKsef?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    qrCodeKsefVerification?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    sentToSymphonyHandelTs?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    sentToSymphonyHandel?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    ksefDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    ksefRejectionReason?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    amountNet?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    amountGross?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    amountNetDelta?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    amountGrossDelta?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    purchaserClientName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    purchaserClientAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    purchaserClientNip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    recipientClientName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    recipientClientAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    recipientClientNip?: string | null;
}


/**
 * @export
 */
export const CreateUpdateSalesInvoiceDtoCurrencyEnum = {
    Pln: 'PLN',
    Usd: 'USD',
    Eur: 'EUR',
    Czk: 'CZK',
    Rub: 'RUB',
    Huf: 'HUF',
    Gbp: 'GBP',
    Bgn: 'BGN',
    Ron: 'RON',
    Hrk: 'HRK',
    Aud: 'AUD'
} as const;
export type CreateUpdateSalesInvoiceDtoCurrencyEnum = typeof CreateUpdateSalesInvoiceDtoCurrencyEnum[keyof typeof CreateUpdateSalesInvoiceDtoCurrencyEnum];

/**
 * @export
 */
export const CreateUpdateSalesInvoiceDtoStatusEnum = {
    Draft: 'Draft',
    Generated: 'Generated',
    Sent: 'Sent',
    InKseF: 'InKSeF',
    Paid: 'Paid'
} as const;
export type CreateUpdateSalesInvoiceDtoStatusEnum = typeof CreateUpdateSalesInvoiceDtoStatusEnum[keyof typeof CreateUpdateSalesInvoiceDtoStatusEnum];

/**
 * @export
 */
export const CreateUpdateSalesInvoiceDtoPaymentFormEnum = {
    BankTransfer: 'BankTransfer',
    Compensation: 'Compensation',
    Prepayment: 'Prepayment',
    Paid: 'Paid'
} as const;
export type CreateUpdateSalesInvoiceDtoPaymentFormEnum = typeof CreateUpdateSalesInvoiceDtoPaymentFormEnum[keyof typeof CreateUpdateSalesInvoiceDtoPaymentFormEnum];

/**
 * @export
 */
export const CreateUpdateSalesInvoiceDtoTypeEnum = {
    Foreign: 'Foreign',
    Domestic: 'Domestic'
} as const;
export type CreateUpdateSalesInvoiceDtoTypeEnum = typeof CreateUpdateSalesInvoiceDtoTypeEnum[keyof typeof CreateUpdateSalesInvoiceDtoTypeEnum];

/**
 * @export
 */
export const CreateUpdateSalesInvoiceDtoStatusKsefEnum = {
    AcceptedInKseF: 'AcceptedInKSeF',
    RejectedInKseF: 'RejectedInKSeF',
    WaitingForKseF: 'WaitingForKSeF',
    Offline: 'OFFLINE'
} as const;
export type CreateUpdateSalesInvoiceDtoStatusKsefEnum = typeof CreateUpdateSalesInvoiceDtoStatusKsefEnum[keyof typeof CreateUpdateSalesInvoiceDtoStatusKsefEnum];


/**
 * Check if a given object implements the CreateUpdateSalesInvoiceDto interface.
 */
export function instanceOfCreateUpdateSalesInvoiceDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "currency" in value;
    isInstance = isInstance && "number" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "paymentForm" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "invoiceDate" in value;
    isInstance = isInstance && "saleDate" in value;
    isInstance = isInstance && "payableDaysId" in value;
    isInstance = isInstance && "printProjectNumber" in value;
    isInstance = isInstance && "isPaymentFromReceiptDate" in value;
    isInstance = isInstance && "projectIds" in value;
    isInstance = isInstance && "isOnePositionOnInvoice" in value;
    isInstance = isInstance && "onePositionName" in value;
    isInstance = isInstance && "exchangeRate" in value;
    isInstance = isInstance && "exchangeRateDescription" in value;
    isInstance = isInstance && "gtuCodeId" in value;
    isInstance = isInstance && "documentCodeIds" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "textOverItems" in value;
    isInstance = isInstance && "toKsef" in value;

    return isInstance;
}

export function CreateUpdateSalesInvoiceDtoFromJSON(json: any): CreateUpdateSalesInvoiceDto {
    return CreateUpdateSalesInvoiceDtoFromJSONTyped(json, false);
}

export function CreateUpdateSalesInvoiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateSalesInvoiceDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'currency': json['currency'],
        'number': json['number'],
        'status': json['status'],
        'paymentForm': json['paymentForm'],
        'type': json['type'],
        'invoiceDate': (new Date(json['invoiceDate'])),
        'saleDate': (new Date(json['saleDate'])),
        'payableDaysId': json['payableDaysId'],
        'printProjectNumber': json['printProjectNumber'],
        'isPaymentFromReceiptDate': json['isPaymentFromReceiptDate'],
        'projectIds': json['projectIds'],
        'isOnePositionOnInvoice': json['isOnePositionOnInvoice'],
        'onePositionName': json['onePositionName'],
        'exchangeRate': json['exchangeRate'],
        'exchangeRateDescription': json['exchangeRateDescription'],
        'gtuCodeId': json['gtuCodeId'],
        'documentCodeIds': json['documentCodeIds'],
        'active': json['active'],
        'parentId': !exists(json, 'parentId') ? undefined : json['parentId'],
        'textOverItems': json['textOverItems'],
        'correctionReasonTxt': !exists(json, 'correctionReasonTxt') ? undefined : json['correctionReasonTxt'],
        'correctionReasonDictId': !exists(json, 'correctionReasonDictId') ? undefined : json['correctionReasonDictId'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'purchaserId': !exists(json, 'purchaserId') ? undefined : json['purchaserId'],
        'recipientClientId': !exists(json, 'recipientClientId') ? undefined : json['recipientClientId'],
        'budgetId': !exists(json, 'budgetId') ? undefined : json['budgetId'],
        'approverId': !exists(json, 'approverId') ? undefined : json['approverId'],
        'approvedTs': !exists(json, 'approvedTs') ? undefined : (json['approvedTs'] === null ? null : new Date(json['approvedTs'])),
        'emailText': !exists(json, 'emailText') ? undefined : json['emailText'],
        'emailSubject': !exists(json, 'emailSubject') ? undefined : json['emailSubject'],
        'toKsef': json['toKsef'],
        'statusKsef': !exists(json, 'statusKsef') ? undefined : json['statusKsef'],
        'numberKsef': !exists(json, 'numberKsef') ? undefined : json['numberKsef'],
        'qrCodeKsef': !exists(json, 'qrCodeKsef') ? undefined : json['qrCodeKsef'],
        'qrCodeKsefVerification': !exists(json, 'qrCodeKsefVerification') ? undefined : json['qrCodeKsefVerification'],
        'sentToSymphonyHandelTs': !exists(json, 'sentToSymphonyHandelTs') ? undefined : (json['sentToSymphonyHandelTs'] === null ? null : new Date(json['sentToSymphonyHandelTs'])),
        'sentToSymphonyHandel': !exists(json, 'sentToSymphonyHandel') ? undefined : json['sentToSymphonyHandel'],
        'ksefDate': !exists(json, 'ksefDate') ? undefined : (json['ksefDate'] === null ? null : new Date(json['ksefDate'])),
        'ksefRejectionReason': !exists(json, 'ksefRejectionReason') ? undefined : json['ksefRejectionReason'],
        'amountNet': !exists(json, 'amountNet') ? undefined : json['amountNet'],
        'amountGross': !exists(json, 'amountGross') ? undefined : json['amountGross'],
        'amountNetDelta': !exists(json, 'amountNetDelta') ? undefined : json['amountNetDelta'],
        'amountGrossDelta': !exists(json, 'amountGrossDelta') ? undefined : json['amountGrossDelta'],
        'purchaserClientName': !exists(json, 'purchaserClientName') ? undefined : json['purchaserClientName'],
        'purchaserClientAddress': !exists(json, 'purchaserClientAddress') ? undefined : json['purchaserClientAddress'],
        'purchaserClientNip': !exists(json, 'purchaserClientNip') ? undefined : json['purchaserClientNip'],
        'recipientClientName': !exists(json, 'recipientClientName') ? undefined : json['recipientClientName'],
        'recipientClientAddress': !exists(json, 'recipientClientAddress') ? undefined : json['recipientClientAddress'],
        'recipientClientNip': !exists(json, 'recipientClientNip') ? undefined : json['recipientClientNip'],
    };
}

export function CreateUpdateSalesInvoiceDtoToJSON(value?: CreateUpdateSalesInvoiceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'currency': value.currency,
        'number': value.number,
        'status': value.status,
        'paymentForm': value.paymentForm,
        'type': value.type,
        'invoiceDate': (value.invoiceDate.toISOString()),
        'saleDate': (value.saleDate.toISOString()),
        'payableDaysId': value.payableDaysId,
        'printProjectNumber': value.printProjectNumber,
        'isPaymentFromReceiptDate': value.isPaymentFromReceiptDate,
        'projectIds': value.projectIds,
        'isOnePositionOnInvoice': value.isOnePositionOnInvoice,
        'onePositionName': value.onePositionName,
        'exchangeRate': value.exchangeRate,
        'exchangeRateDescription': value.exchangeRateDescription,
        'gtuCodeId': value.gtuCodeId,
        'documentCodeIds': value.documentCodeIds,
        'active': value.active,
        'parentId': value.parentId,
        'textOverItems': value.textOverItems,
        'correctionReasonTxt': value.correctionReasonTxt,
        'correctionReasonDictId': value.correctionReasonDictId,
        'companyId': value.companyId,
        'purchaserId': value.purchaserId,
        'recipientClientId': value.recipientClientId,
        'budgetId': value.budgetId,
        'approverId': value.approverId,
        'approvedTs': value.approvedTs === undefined ? undefined : (value.approvedTs === null ? null : value.approvedTs.toISOString()),
        'emailText': value.emailText,
        'emailSubject': value.emailSubject,
        'toKsef': value.toKsef,
        'statusKsef': value.statusKsef,
        'numberKsef': value.numberKsef,
        'qrCodeKsef': value.qrCodeKsef,
        'qrCodeKsefVerification': value.qrCodeKsefVerification,
        'sentToSymphonyHandelTs': value.sentToSymphonyHandelTs === undefined ? undefined : (value.sentToSymphonyHandelTs === null ? null : value.sentToSymphonyHandelTs.toISOString()),
        'sentToSymphonyHandel': value.sentToSymphonyHandel,
        'ksefDate': value.ksefDate === undefined ? undefined : (value.ksefDate === null ? null : value.ksefDate.toISOString()),
        'ksefRejectionReason': value.ksefRejectionReason,
        'amountNet': value.amountNet,
        'amountGross': value.amountGross,
        'amountNetDelta': value.amountNetDelta,
        'amountGrossDelta': value.amountGrossDelta,
        'purchaserClientName': value.purchaserClientName,
        'purchaserClientAddress': value.purchaserClientAddress,
        'purchaserClientNip': value.purchaserClientNip,
        'recipientClientName': value.recipientClientName,
        'recipientClientAddress': value.recipientClientAddress,
        'recipientClientNip': value.recipientClientNip,
    };
}

